import React, { useContext, useEffect, useState } from 'react';
import { WardrobesConfigsContext } from '../contexts/WardrobesConfigsContext';
import { WardrobeHeightContext } from '../contexts/WardrobeHeightContext';
import { ActiveWardrobeContext } from '../contexts/ActiveWardrobeContext';
import AccessoriesRow from '../components/BuyAccessories/AccessoriesRow';
import SelectionButtons from '../components/buttons/SelectionButtons';
import ProgressBar from '../components/ProgressBar';
import RangeSlider from '../components/common/RangeSlider';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getAccessoriesListShop } from '../store/actions/accessories';
import { ownProgressive } from '../helpers/buyAccessories';

const filterAndGroupList = (items, width, depth) => {
  let filteredList = [...items].filter(item => {
    if (item.assigned_led.length) {
      let hasItems = item.assigned_led.filter(row => {
        return row.z === depth && row.x === width && row.y === 240;
      });
      return hasItems.length > 0;
    } else {
      return (
        item.assigned_to.hasOwnProperty(depth) && item.assigned_to[depth].x.indexOf(width) !== -1
      );
    }
  });

  filteredList = filteredList.filter(row => !row.hasOwnProperty('group') && !row.group);

  // wyfiltrowanie oświetlenia
  const lights = filteredList.filter(row => row.slug.includes('al_bi4k'));
  const withoutLEDs = filteredList.filter(row => !row.slug.includes('al_bi4k'));

  if (lights.length) {
    filteredList = withoutLEDs;
    let lightsList = {};

    lights.forEach(item => {
      item.assigned_led.forEach(row => {
        if (
          !lightsList.hasOwnProperty(row.side) &&
          row.z === depth &&
          row.x === width &&
          row.y === 240
        ) {
          lightsList[row.side] = JSON.parse(JSON.stringify(item));
        }
      });
    });

    let lightsTmp = JSON.parse(JSON.stringify(lightsList));
    lightsTmp = Object.assign({}, lightsList.left);

    if (lightsList.left) {
      let newPoductInfo = {
        safo: [],
        regular: 0.0,
        special: 0.0,
        actual: 0.0,
      };

      Object.values(lightsList).forEach(item => {
        newPoductInfo.safo.push(item.safo);
        newPoductInfo.regular += parseFloat(item.price.regular);
        newPoductInfo.actual += parseFloat(item.price.actual);
        newPoductInfo.special += parseFloat(item.price.special);
      });

      lightsTmp.safo = newPoductInfo.safo.join(',');
      lightsTmp.price.actual = newPoductInfo.actual;
      lightsTmp.price.regular = newPoductInfo.regular;
      lightsTmp.price.special = newPoductInfo.special;
      lightsTmp.group = true;

      filteredList.push(lightsTmp);
    }
  }

  return filteredList;
};

const BuyAccessories = props => {
  const { wardrobeHeight } = useContext(WardrobeHeightContext);
  const { activeWardrobe } = useContext(ActiveWardrobeContext);
  const { wardrobesConfigs, setWardrobesConfigs } = useContext(WardrobesConfigsContext);
  const [accessoriesList, setAccessoriesList] = useState({
    list: [],
    filter: {
      width: 180,
      depth: 66,
    },
    filteredList: [],
    loaded: false,
  });

  let depthArr = [];
  const { dimensions, accessoriesListShop, productsHull, defaultHull } = props;
  let slidePoints = [];
  if (dimensions) {
    depthArr = Object.keys(dimensions.depth).map(item => dimensions.depth[item]);
    slidePoints = [].concat(...Object.values(dimensions?.width || {}));
    slidePoints = slidePoints.filter(slidePoint => typeof slidePoint === 'number');
  }

  useEffect(() => {
    let productsHullTmp = [...productsHull];
    let defaultHullInfo = defaultHull[7] ?? null;

    if (!!defaultHullInfo) {
      defaultHullInfo.dimensions.y = wardrobeHeight;
      let filteredData = productsHullTmp.filter(item => {
        return (
          item.dimensions.x === defaultHullInfo.dimensions.x &&
          item.dimensions.y === defaultHullInfo.dimensions.y &&
          item.dimensions.z === defaultHullInfo.dimensions.z
        );
      });

      let wardrobeHull = filteredData.find(item => {
        return item.safo.includes(defaultHullInfo.colorName);
      });

      let wardrobeConfig = [wardrobeHull];
      wardrobeConfig[activeWardrobe] = {
        ...wardrobeConfig[activeWardrobe],
        height: wardrobeHeight,
      };

      setWardrobesConfigs(wardrobeConfig);
    }
    /* eslint-disable-next-line */
  }, [productsHull, wardrobeHeight]);

  useEffect(() => {
    let params = { ...accessoriesList };
    if (!accessoriesList.loaded) {
      props.getAccessories();
      params.loaded = true;
    }

    if (!!accessoriesListShop) {
      params.list = [...accessoriesListShop];
      params.filteredList = filterAndGroupList(
        accessoriesListShop,
        params.filter.width,
        params.filter.depth,
      );
    }
    setAccessoriesList(params);
    /* eslint-disable-next-line */
  }, [accessoriesListShop, props]);

  useEffect(() => {
    setWidthValue([200.7]);
    /* eslint-disable-next-line */
  }, [slidePoints.length]);

  const setFilter = (value, index) => {
    let filter = {
      ...accessoriesList.filter,
      [index]: value,
    };

    setAccessoriesList({
      ...accessoriesList,
      filteredList: filterAndGroupList(accessoriesListShop, filter.width, filter.depth),
      filter: filter,
    });
  };

  const setWidthValue = value => {
    setFilter(value[0], 'width');
  };

  const setDepthValue = value => {
    setFilter(value, 'depth');
  };

  const productsListSorted = accessoriesList.filteredList.sort((a, b) => {
    return a.name.localeCompare(b.name);
  });

  return (
    <div className="container buy-accessories">
      <ProgressBar activeLvl={0} ownProgressive={ownProgressive} hideInactive />
      <h3 className="buy-accessories__title">
        Wybierz głębokość oraz szerokość, żebyśmy mogli dopasować odpowiednie akcesoria do Twojej
        szafy.
      </h3>
      <div className="container buy-accessories__dimensions">
        {!!dimensions && !!wardrobeHeight && (
          <div className="buy-accessories__dimensions-item">
            <SelectionButtons
              title="Głębokość szafy:"
              selectionGroupName="width"
              params={depthArr}
              unit="cm"
              setValue={setDepthValue}
              activeValue={accessoriesList.filter.depth}
            />
          </div>
        )}
        <div className="buy-accessories__dimensions-item">
          <RangeSlider
            slidePoints={slidePoints}
            sliderName="Szerokość:"
            activeValue={accessoriesList.filter.width}
            unit="cm"
            changeSize={setWidthValue}
            wardrobesConfigs={wardrobesConfigs}
            activeWardrobe={activeWardrobe}
          />
        </div>
      </div>
      {productsListSorted.length === 0 ? (
        <>
          <div className="loader" />
          <p className="loader__text">Ładowanie...</p>
        </>
      ) : (
        <ul className="buy-accessories__list">
          {productsListSorted.map((item, index) => (
            <AccessoriesRow item={item} index={index} key={item.safo + index} />
          ))}
        </ul>
      )}
    </div>
  );
};

const mapStateToProps = state => {
  return {
    ...state,
    productsHull: state.products.wardrobeHulls,
    defaultHull: state.defaults.hull,
    accessoriesListShop: state.accessories.accessoriesListShop,
    dimensions: state.dimensions.dimensions,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getAccessories: () => dispatch(getAccessoriesListShop()),
  };
};

BuyAccessories.propTypes = {
  dimensions: PropTypes.object,
  accessoriesListShop: PropTypes.arrayOf(PropTypes.object),
};

export default connect(mapStateToProps, mapDispatchToProps)(BuyAccessories);
